import {gql} from '@apollo/client';
import {noop} from '@benchling/js-utils';
import React, {useEffect} from 'react';

import {setWindowTitle} from 'BenchlingUtil';
import ChemicalCounterpartLibrary from 'chemistry/ChemicalCounterpartLibrary';
import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {ErrorFragment} from 'graphql-client/Error';
import {TABLE_KEYS} from 'ui-library/scrollable/ScrollableTableConstants';

import {SaltLibraryQuery} from './__generated/SaltLibraryQuery';

export const SALT_LIBRARY_QUERY = gql`
  query SaltLibraryQuery @skipAudit @engComponent(name: CHEMISTRY) {
    salts {
      id
      name
      code
      molecularFormula
      calculatedMolecularWeight
      canonicalSmiles
      imageData {
        ... on SVGNode {
          base64Svg
        }
        ...Error
      }
    }
  }
  ${ErrorFragment.fragment}
`;

export default function SaltLibrary(): JSX.Element {
  useEffect(() => {
    setWindowTitle('Salts');
  }, []);

  const result = useBenchlingQuery<SaltLibraryQuery>(SALT_LIBRARY_QUERY);

  return (
    <ChemicalCounterpartLibrary
      title="Salt library"
      addNewLabel="Add new salt"
      items={result.type === QueryResultType.SUCCESS ? result.data.salts : []}
      loading={result.type === QueryResultType.PENDING}
      tableKey={TABLE_KEYS.SALT_LIBRARY_TABLE}
      searchPlaceholder="Salt name or code"
      onAddNew={noop}
    />
  );
}
